import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { leadingZero } from '@/shared/lib/utils/numberFormatters';
export default /*#__PURE__*/_defineComponent({
  __name: 'TimeOutput',
  props: {
    input: null,
    format: {
      default: 'sDATE - eDATE'
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    function timeOutput(date) {
      var d = new Date(date);
      var hours = leadingZero(d.getHours());
      var minutes = leadingZero(d.getMinutes());
      return "".concat(hours, ":").concat(minutes);
    }
    var output = computed(function () {
      var _props$input = props.input,
        startDate = _props$input.startDate,
        endDate = _props$input.endDate;
      var startTime = timeOutput(startDate);
      if (!endDate) {
        return startTime;
      }
      var endTime = timeOutput(endDate);
      if (startTime === endTime) {
        return startTime;
      }
      var symbols = props.format.match(/[s,e]DATE/g);
      var params = {
        sDATE: startTime,
        eDATE: endTime
      };
      return symbols.reduce(function (str, symbol) {
        return str.replace(symbol, params[symbol]);
      }, props.format);
    });
    return {
      __sfc: true,
      props: props,
      timeOutput: timeOutput,
      output: output
    };
  }
});